<template>
  <div class="gf_pricing__plan__row row">
    <div
      class="gf_pricing__plan__item"
      v-for="(content, key) in dynamicContent.plans"
      :key="key"
      :class="`col-${
        dynamicContent.plans &&
        (dynamicContent.plans.trial ||
          dynamicContent.plans.starter ||
          dynamicContent.plans.trial2022 || 
          dynamicContent.plans.development_store || 
          dynamicContent.plans.development || 
          dynamicContent.plans.development2022) 
          ? 3
          : 4
      }`"
    > 
      <slot v-bind="{content, key}"></slot>
    </div>
  </div>
  
</template>

<script>
import promotion from "@/modules/Pricing/mixins/promotion";
import plan from "@/modules/Pricing/mixins/plan";
import planItem from "@/modules/Pricing/mixins/planItem";

export default {
  name: "PlanPricingRow",
  mixins: [promotion(), plan(), planItem()],
};
</script>
